import $ from 'jquery';
import chroma from 'chroma-js';

function getColorScale(steps) {
  if (!steps) {
    return false;
  }

  const colors = steps.slice(0, steps.length - 1).map(step => step[1]);
  const classes = steps.map(step => step[0]);

  return chroma.scale(colors).classes(classes);
}

export const getColorizer = (colorKey, valueKey, steps) => {
  const scale = getColorScale(steps);
  return props => scale ? scale(props[valueKey]) : props[colorKey];
}

export function scrollMapIntoViewport() {
  const $mapWrapper = $('.map-wrapper');
  const mapTop = $mapWrapper.offset().top;

  if (window.scrollY > mapTop) {
    $('html').animate({ scrollTop: mapTop });
  }
}

export function disableMap(map) {
  if ('ontouchstart' in window) {
    map.dragging.disable();
    if (map.tap) map.tap.disable();
  }

  map.doubleClickZoom.disable();
  map.scrollWheelZoom.disable();
  map.boxZoom.disable();
  map.keyboard.disable();
}

export function enableMap(map) {
  if ('ontouchstart' in window) {
    map.dragging.enable();
    if (map.tap) map.tap.enable();
  }

  map.doubleClickZoom.enable();
  map.scrollWheelZoom.enable();
  map.boxZoom.enable();
  map.keyboard.enable();
}

export function getColorsBySteps(colorSteps = null) {
  return colorSteps.filter(cs => cs.length === 2).map(cs => ({ key: cs[1] }));
}

export function getColorsByData({ colorKey = null, valueKey = null, data = {} }) {
  if (colorKey && valueKey && data && data.features) {
    const colorValues = data.features.reduce((res, item) => {
      const currColor = item.properties[colorKey];
      const currValue = item.properties[valueKey];
      const currObject = res.find(d => d.key === currColor);

      if (!currColor || !currValue) {
        return res;
      }

      if (!currObject) {
        res.push({ key: currColor, values: [] });
      }

      return res.map(d => ({
        key: d.key,
        values: d.key === currColor ? d.values.concat(currValue) : d.values
      }));
    }, []);

    const colorValuesSorted = colorValues.map(cv => ({ key: cv.key, values: cv.values.sort() }));
    const colorSteps = colorValuesSorted.sort((a, b) => {
      if (a.values[0] > b.values[0]) {
        return 1;
      } else if (a.values[0] < b.values[0]) {
        return -1;
      }

      return 0;
    })

    return colorSteps;
  }

  return [];
}

export default {
  getColorizer,
  scrollMapIntoViewport,
  disableMap,
  enableMap,
  getColorsBySteps,
  getColorsByData
}
